import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SessionHelper } from '../../../shared/services/localstorage';
import{SpeakerService} from '../../../../globalservices/speaker/speaker.service';
@Component({
  selector: 'app-myTrainin',
  templateUrl: './myTraining.component.html',
  styleUrls: ['./myTraining.component.scss']
})
export class MyTrainingComponent implements OnInit {
  cards:any=[];
  userObj:any;
  id:any;
  isLoading=false;
  constructor(private router:Router,private speakerService:SpeakerService) { }

  ngOnInit() {
    this.userObj = SessionHelper.getSession();
    this.id=this.userObj.id;
  //  this.getTrainigData();
  this.getAllTraning();
  }
  getAllTraning(){
    this.isLoading=true;
    this.speakerService.getAllTraining(this.userObj.id,this.userObj.brand_id,'5','0','PROCESSING')
    .subscribe((result:any)=>{
      this.isLoading=false;
      if(result.data.length>0){
        for(let i=0;i<result.data.length;i++){
          console.log("result.data",result.data[i].status);
          if(result.data[i].status=='PROCESSING'){
            this.cards.push(result.data[i]);
          }
        }
      }
     })
    }
    onTraningDetails(training){
      this.router.navigate(['trainingdetail/',training.id]);
    }
  // getTrainigData(){
  //   console.log("getTraining response");
  //   let data = {"limit":3,"start":0,"sort_column":"1" ,"sort_order":"asc"}
  //   this.speakerService.getTraining(3,0,this.id)
  //   .subscribe((response:any)=>{
  //    console.log("getTraining response",response.data);
  //   this.cards=response.data;
  //   })
  // }
  getStatus(status) {
    switch (status) {
      case 'COMPLETED': return "Completed";
      case 'PROCESSING': return "In Progress";
      case 'NOT-STARTED': return "Not Started";
    }
  }

  getClass(cls) {
    switch (cls) {
      case 'COMPLETED': return "completed-color";
      case 'PROCESSING': return "progress-color";
      case 'NOT-STARTED': return "notstated-color";
    }
  }
}
